export default {
    tab: 'Καμπύλες ανάπτυξης',
    subtitle: 'Οι μετρήσεις του πελάτη σου σε σύγκριση με παιδιά του ίδιου φύλου και ηλικίας',
    charts: {
        'weight-length-0-2': {
            title: 'Βάρος και μήκος ανάλογα με την ηλικία',
            short: 'Βάρος και μήκος 0–2',
            ages: '0–2 ετών',
        },
        'weight-for-length-0-2': {
            title: 'Βάρος ανάλογα με το μήκος του σώματος',
            short: 'Βάρος-προς-μήκος 0–2',
            ages: '0–2 ετών',
        },
        'weight-length-height-0-5': {
            title: 'Βάρος και μήκος/ύψος ανάλογα με την ηλικία',
            short: 'Βάρος και μήκος/ύψος 0–5',
            ages: '0–5 ετών',
        },
        'head-circumference-0-5': {
            title: 'Περίμετρος κεφαλής ανάλογα με την ηλικία',
            short: 'Περίμετρος κεφαλής 0–5',
            ages: '0–5 ετών',
        },
        'weight-height-5-18': {
            title: 'Βάρος και ύψος ανάλογα με την ηλικία',
            short: 'Βάρος και ύψος 5–18',
            ages: '5–18 ετών',
        },
        'bmi-2-18': {
            title: 'Δείκτης μάζας σώματος ανάλογα με την ηλικία',
            short: 'ΔΜΣ 2–18',
            ages: '2–18 ετών',
        },
    },
    pastCharts: 'Προηγούμενα διαγράμματα',
    sexes: {
        F: 'Κορίτσια',
        M: 'Αγόρια',
    },
    sources: {
        who2006: 'Πηγή: Παγκόσμιος Οργανισμός Υγείας (WHO Child Growth Standards)',
        who2007: 'Πηγή: Παγκόσμιος Οργανισμός Υγείας (2007 WHO Reference)',
        iotf2012: 'Πηγή: International Obesity Task Force (Revised BMI cut-offs, 2012)',
    },
    measures: {
        length: 'Μήκος/ύψος',
        height: 'Ύψος',
        weight: 'Βάρος',
        head: 'Περίμετρος κεφαλής',
        bmi: 'ΔΜΣ',
    },
    axis: {
        ageYears: 'Ηλικία (έτη)',
        ageMonths: 'Ηλικία (έτη / μήνες)',
        length: 'Μήκος σώματος (cm)',
    },
    birth: 'Γέννηση',
    years: '{count} έτους | {count} ετών',
    age: {
        years: '{count} έτος | {count} έτη',
        months: '{count} μήνας | {count} μήνες',
    },
    centile: '{centile} εκατοστημόριο',
    centileWord: 'εκατοστημόριο',
    // by Intl.PluralRules' ordinal category, which in Greek is always «other»
    ordinal: {
        other: '{n}ο',
    },
    zScore: 'z {value}',
    adultBmi: 'Ισοδύναμος ΔΜΣ ενήλικα (IOTF): {value}',
    heightFrom: 'Ύψος από {date}',
    notes: {
        lengthHeight: {
            line1: 'Έως τα 2 έτη σημειώνεται το μήκος σώματος (ξαπλωμένο).',
            line2: 'Από τα 2 έτη σημειώνεται το ύψος (όρθιο).',
        },
        weightAfterTen: {
            line1: 'Από την εφηβεία, το βάρος για την ηλικία',
            line2: 'δεν είναι ικανοποιητικό κριτήριο',
            line3: 'για ελλιπές ή υπέρμετρο βάρος.',
            line4: 'Μετά τα 10 έτη δες το διάγραμμα ΔΜΣ.',
        },
        iotf: {
            title: 'Οι γραμμές αντιστοιχούν σε ΔΜΣ 30, 25, 18.5, 17 και 16 στα 18 έτη',
            obesity: 'Στη γραμμή 30 ή πάνω: παχυσαρκία',
            overweight: 'Στη γραμμή 25 ή πάνω (έως 30): υπέρβαρο',
            thinness1: 'Κάτω από 18.5 (έως 17): ελαφρά ελλιπές βάρος',
            thinness2: 'Κάτω από 17 (έως 16): μέτρια ελλιπές βάρος',
            thinness3: 'Κάτω από 16: σοβαρά ελλιπές βάρος',
            severeObesity: 'Στο ισοδύναμο του ΔΜΣ 35 ή πάνω: σοβαρή παχυσαρκία',
        },
    },
    categories: {
        severeObesity: 'Σοβαρή παχυσαρκία',
        obesity: 'Παχυσαρκία',
        overweight: 'Υπέρβαρο',
        normal: 'Φυσιολογικό βάρος',
        thinness1: 'Ελαφρά ελλιπές βάρος',
        thinness2: 'Μέτρια ελλιπές βάρος',
        thinness3: 'Σοβαρά ελλιπές βάρος',
    },
    zoom: {
        full: 'Όλο το διάγραμμα',
        focus: 'Εστίαση στις μετρήσεις',
        label: 'Εύρος διαγράμματος',
    },
    cards: {
        bmi: 'ΔΜΣ (IOTF)',
        bmiDetail: '{bmi} kg/m² · {weight} kg, {height} cm',
        bmiNeedsHeight: 'Πρόσθεσε νέο ύψος για ενημερωμένο ΔΜΣ',
        length: 'Μήκος',
        weightForLength: 'Βάρος-προς-μήκος',
        weightForLengthDetail: '{weight} kg με μήκος {length} cm',
    },
    trend: {
        from: 'από {value} ({date})',
        stable: 'σταθερό',
        channelChange: 'αλλαγή καναλιού',
        sd: '{value} SD',
    },
    table: {
        title: 'Μετρήσεις',
        date: 'Ημερομηνία',
        age: 'Ηλικία',
        showAll: 'Όλες οι μετρήσεις ({count})',
        showLess: 'Λιγότερες',
        heightFrom: 'από {date}',
    },
    missing: {
        title: 'Λείπουν στοιχεία του πελάτη',
        text: 'Για να δεις τις καμπύλες ανάπτυξης, συμπλήρωσε {fields} στο προφίλ του πελάτη.',
        sex: 'το φύλο',
        birthDate: 'την ημερομηνία γέννησης',
        and: 'και',
    },
    failed: {
        title: 'Δεν φόρτωσαν οι καμπύλες ανάπτυξης',
        text: 'Κάτι πήγε στραβά. Δοκίμασε ξανά σε λίγο.',
        retry: 'Δοκίμασε ξανά',
    },
    implausible: {
        short: 'έλεγξε τη μέτρηση',
        tooltip: 'Εκτός των ορίων του ΠΟΥ: έλεγξε τη μέτρηση',
    },
    preterm: 'Χρονολογική ηλικία, χωρίς διόρθωση για πρόωρα',
    noPoints: 'Πρόσθεσε ύψος και βάρος στις σωματομετρικές μετρήσεις για να σημειωθούν στο διάγραμμα.',
    noCharts: 'Οι καμπύλες ανάπτυξης αφορούν πελάτες έως 18 ετών.',
    noChartsTitle: 'Δεν υπάρχουν καμπύλες για αυτή την ηλικία',
    print: {
        customer: 'Πελάτης',
        birthDate: 'Ημ. γέννησης',
        centileNote: 'Εκατοστημόριο: στο 85ο, 85 στα 100 παιδιά ίδιου φύλου και ηλικίας έχουν μικρότερη τιμή.',
        screeningNote: 'Οι καμπύλες ανάπτυξης είναι εργαλείο παρακολούθησης, όχι διάγνωσης.',
    },
};
